import { all, takeEvery, put, call } from "redux-saga/effects";
import { notification } from "antd";
import actions from "./actions";
import {
  getAllOrganizationsSummaryRequest,
  addOrganizationRequest,
  getAllCitiesRequest,
  deleteOrganizationRequest,
  updateOrganizationRequest,
  getAllRestauranstsRequest,
  checkFireBirdDbVersionsRequest,
  checkFireBirdDbVersionsByUserRequest,
  getMenuConfigurationRequest,
  checkOrganization,
  getAllOrganizationsByUrlRequest,
  getOrganizationDetailsRequest,
} from "../../services/organizationsService";
import { getToken } from "../../utils/utility";

export function* getOrganizations() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllOrganizationsSummaryRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ORGANIZATIONS_SUCCESS,
        organizations: response[1],
      });
    } else {
      notification["error"]({
        message: "Неуспешно взимане на организации.",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на организации.",
    });
  }
}

export function* getOrganizationDetails({ organizationId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getOrganizationDetailsRequest, organizationId, token);
    if (response[0] === 200 && Array.isArray(response[1]) && response[1].length > 0) {
      yield put({
        type: actions.GET_ORGANIZATION_DETAILS_SUCCESS,
        organization: response[1][0],
      });
    } else {
      yield put({
        type: actions.GET_ORGANIZATION_DETAILS_FAILURE,
      });
      notification["error"]({
        message: "Неуспешно зареждане на детайли за организация.",
      });
    }
  } catch (error) {
    yield put({
      type: actions.GET_ORGANIZATION_DETAILS_FAILURE,
    });
    notification["error"]({
      message: "Неуспешно зареждане на детайли за организация.",
    });
  }
}

export function* addOrganization({ organization }) {
  const token = getToken().get("idToken");
  try {
    const response = yield call(addOrganizationRequest, organization, token);
    if (response[0] === 200) {
      yield put({
        type: actions.ADD_ORGANIZATION_SUCCESS,
      });
      notification["success"]({
        message: "Успешен запис",
      });
    } else {
      notification["error"]({
        message: "Неуспешен запис",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешен запис",
    });
  }
}

export function* deleteOrganization({ organization }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(deleteOrganizationRequest, token, organization);
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_ORGANIZATION_SUCCESS,
      });

      notification["success"]({
        message: "Успешно изтриване.",
      });
    } else {
      notification["error"]({
        message: "Неуспешно изтриване на организация.",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно изтриване на организация.",
    });
  }
}

export function* updateOrganization({ organization }) {
  const token = getToken().get("idToken");
  try {
    const response = yield call(updateOrganizationRequest, organization, token);
    if (response[0] === 200) {
      yield put({
        type: actions.UPDATE_ORGANIZATION_SUCCESS,
        organization,
      });

      notification["success"]({
        message: "Успешен запис",
      });
    } else {
      notification["error"]({
        message: "Неуспешен запис",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешен запис",
    });
  }
}

export function* getCities() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllCitiesRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_CITIES_SUCCESS,
        cities: response[1],
      });
    } else {
      notification["error"]({
        message: "Неуспешно получаване на градове.",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на градове.",
    });
  }
}

export function* getMenuConfiguration() {
  try {
    const token = getToken().get("idToken");
    const organizationId = localStorage.getItem("organizationId");
    const response = yield call(
      getMenuConfigurationRequest,
      organizationId,
      token
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_MENU_CONFIGURATION_SUCCESS,
        menuConfiguration: response[1],
      });
    } else {
      notification["error"]({
        message: "Неуспешно взимане на меню конфигурация.",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на меню конфигурация.",
    });
  }
}
export function* getOranizationRestaurants({ organization }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllRestauranstsRequest, token, organization);

    if (response[0] === 200) {
      yield put({
        type: actions.GET_ORGANIZATION_RESTAURANTS_SUCCESS,
        organizationRestaurants: response[1],
      });
    } else {
      yield put({
        type: actions.GET_ORGANIZATION_RESTAURANTS_SUCCESS,
        organizationRestaurants: [],
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на меню конфигурация.",
    });
  }
}

export function* checkFireBirdDbVersions() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(checkFireBirdDbVersionsRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_FIREBIRD_DATABASE_VERSIONS_SUCCESS,
        fbdbversions: response[1],
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на версиите.",
    });
  }
}

export function* checkFireBirdDbVersionsByUser() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(checkFireBirdDbVersionsByUserRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_SUCCESS,
        fbdbversions: response[1],
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на версиите.",
    });
  }
}

export function* checkOrganizationConnectionRequest({ connectionString }) {
  const token = getToken().get("idToken");
  try {
    const response = yield call(checkOrganization, connectionString, token);

    if (response[0] === 200) {
      response[1] === true
        ? notification["success"]({
            message: "Установена е връзка",
          })
        : notification["error"]({
            message: "Няма връзка с клиента",
          });
    } else {
      notification["error"]({
        message: "Неуспешна проверка",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешна проверка",
    });
  }
}

export function* getAllOrganizationsByUrl({ organizationIds }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getAllOrganizationsByUrlRequest,
      organizationIds,
      token
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ALL_ORGANIZATIONS_BY_URL_SUCCESS,
        organizations: response[1],
      });
    } else {
      notification["error"]({
        message: "Неуспешно взимане на организации.",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на организации.",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_ORGANIZATIONS_REQUEST, getOrganizations),
    yield takeEvery(actions.ADD_ORGANIZATION_REQUEST, addOrganization),
    yield takeEvery(actions.DELETE_ORGANIZATION_REQUEST, deleteOrganization),
    yield takeEvery(actions.GET_CITIES_REQUEST, getCities),
    yield takeEvery(actions.UPDATE_ORGANIZATION_REQUEST, updateOrganization),
    yield takeEvery(
      actions.GET_ORGANIZATION_RESTAURANTS_REQUEST,
      getOranizationRestaurants
    ),
    yield takeEvery(
      actions.GET_FIREBIRD_DATABASE_VERSIONS_REQUEST,
      checkFireBirdDbVersions
    ),
    yield takeEvery(
      actions.GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_REQUEST,
      checkFireBirdDbVersionsByUser
    ),
    yield takeEvery(
      actions.GET_MENU_CONFIGURATION_REQUEST,
      getMenuConfiguration
    ),
    yield takeEvery(
      actions.CHECK_ORGANIZATION_CONNECTION_REQUEST,
      checkOrganizationConnectionRequest
    ),
    yield takeEvery(
      actions.GET_ALL_ORGANIZATIONS_BY_URL_REQUEST,
      getAllOrganizationsByUrl
    ),
    yield takeEvery(
      actions.GET_ORGANIZATION_DETAILS_REQUEST,
      getOrganizationDetails
    ),
  ]);
}
